<template>
  <div class="card-table">
    <div class="toggle-table">
      <div class="sac__font-32 f-white semi-bold">
        {{ header }}
      </div>
      <button @click="toggleShow(!showTable)">
        <img
          v-if="showTable"
          src="../../../assets/img/service/chevron-up.svg"
          class="img-size-14 margin-left-8"
          alt="top"
        >
        <img
          v-else
          src="../../../assets/img/service/white-chev-down.svg"
          class="img-size-14 margin-left-8"
          alt="down"
        >
      </button>
    </div>
    <div
      :class="[
        'card-table-container',
        showTable ? 'show' : 'hide',
      ]"
    >
      <div v-if="showTable">
        <div v-if="tableData.length" class="table-data">
          <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            hide-default-footer
          />
        </div>
        <div v-else class="no-data-container bg-n90">
          No data available..
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CardTable',
  props: {
    loading: Boolean,
    header: String,
    tableHeaders: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    allTableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showTable: true,
    };
  },
  methods: {
    toggleShow(show) {
      this.showTable = show;
    },
  },
};
</script>

<style lang="scss">
.card-table {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  .toggle-table {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .card-table-container {
    margin-top: 24px;
    overflow: hidden;
    transform-origin: top;
    transform: scaleY(0);
    opacity: 0;
    transition: transform 0.3s ease, opacity 0.3s ease;
    &.show {
      transform: scaleY(1);
      opacity: 1;
    }
    &.hide {
      opacity: 0;
      height: 0;
    }
    .see-all-rows {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.3px;
      text-align: right;
      text-decoration: underline;
      color: $SUNSET100;
    }
    .table-data {
      .v-data-table__wrapper {
        max-height: 400px;
        thead {
          tr {
            height: 4em;
            th {
              font-size: 0.875em;
              color: $WHITE;
              font-weight: bold;
              letter-spacing: 0.3px;
              background-color: $NAVY100;
              text-transform: uppercase;
              &:first-child {
                border-top-left-radius: 10px;
              }
              &:last-child {
                border-top-right-radius: 10px;
              }
            }
          }
        }
        tbody {
          tr {
            background-color: $N90;
            height: 2.5em;
            &:hover {
              background-color: unset !important;
            }
            td {
              border: 0;
              font-size: 0.875em;
              color: $WHITE;
              letter-spacing: 0.3px;
            }
            &:nth-child(even) {
              background-color: $N80;
            }
          }
        }
      }
    }
  }
}

</style>
